import axios from 'axios'
import { format } from '../../../../services/format'
import {
  openweatherDay,
  openweatherMoment,
  openweatherIcon,
  openweatherAtlasIcon,
  openweatherImage
} from './utils'

const baseUrl = 'https://api.openweathermap.org/data/2.5/'
const apiKey = '1b6942ed992ac31a4f34fee08f08fad7'
const defaultLang = 'fr'

const schemaWeather = {
  id: 'id',
  name: 'name',
  date: 'dt',
  day: (data) => openweatherDay(data.dt),
  hour: (data) => openweatherMoment(data.dt, 'HH') + 'h',
  coords: (data) => [data.coord.lon, data.coord.lat],
  icon: (data) => openweatherIcon(data.weather[0].id, data.sys.sunrise, data.sys.sunset),
  aicon: (data) => openweatherAtlasIcon(data.weather[0].id),
  image: (data) => openweatherImage(data.weather[0].id, data.sys.sunrise, data.sys.sunset),
  code: 'weather.0.id',
  desc: 'weather.0.description',
  temp: 'main.temp',
  tempMax: 'main.temp_max',
  tempMin: 'main.temp_max',
  sunset: 'sys.sunset',
  sunrise: 'sys.sunrise',
  wind: 'wind.speed',
  windDeg: 'wind.deg',
  humidity: 'main.humidity',
  pressure: 'main.pressure'
}

export const getWeather = (aLonLat, lang = defaultLang) => {
  const url = `${baseUrl}weather?lat=${aLonLat[1]}&lon=${aLonLat[0]}&lang=${lang}&appid=${apiKey}`
  return new Promise((resolve, reject) => {
    axios.get(url)
      .then(res => resolve(format(schemaWeather, res.data)))
      .catch(err => reject(err))
  })
}
// getWeather([2.3488000, 48.8534100]).then(res => console.log(res))

const schemaForecast = {
  name: 'city.name',
  coords: (data) => [data.city.coord.lon, data.city.coord.lat],
  forecast: (data) => data.list.map(d => format(schemaForecastItem, d))
}

const schemaForecastItem = {
  date: 'dt',
  day: (data) => openweatherDay(data.dt),
  hour: (data) => openweatherMoment(data.dt, 'HH') + 'h',
  icon: (data) => openweatherIcon(data.weather[0].id, data.sys.sunrise, data.sys.sunset),
  aicon: (data) => openweatherAtlasIcon(data.weather[0].id),
  image: (data) => openweatherImage(data.weather[0].id),
  desc: 'weather.0.description',
  code: 'weather.0.id',
  temp: 'main.temp',
  wind: 'wind.speed',
  windDeg: 'wind.deg',
  humidity: 'main.humidity'
}

export const getForecast = (station, lang = defaultLang) => {
  const url = `${baseUrl}forecast?id=${station}&lang=${lang}&appid=${apiKey}`
  return new Promise((resolve, reject) => {
    axios.get(url)
      .then(res => {
        resolve(format(schemaForecast, res.data))
      })
      .catch(err => reject(err))
  })
}
// getForcast([2.3488000, 48.8534100]).then(res => console.log(JSON.stringify(res, null, 2)))
